export default "__VITE_ASSET__G88lXxUJ__"